import { Row } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  padding-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.grayBorder};
  width:100%;
  ${'' /* .Report {
    min-width: 27px;
    @media (max-width: 1024px) {
      width: 100% !important;
    }
  } */}
  .City {
    min-width: 180px;
    @media (max-width: 1024px) {
      width: 100% !important;
    }
  }
  @media (max-width: 1024px) {
    flex-wrap: wrap;
  }
  .upload {
    border:none;
  }
  .messageDigital{
    font: 16px/20px 'DMSans-Medium';
    color: #0066A5;
    @media (max-width: 768px) {
    text-align: center;
    width: 100%;
    }
  }
  .review{
   max-width: 180px;        
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  @media (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 10px;

  }
  }
  .Report{
    width: 50%;
  }
  .col-upload{
    width: 50%;
    padding: 0;
    @media (max-width: 768px) {
      width:100%;
    }
  }
  .Img{
    @media (max-width: 768px) {
      width: ${(props) => props.statusCode === 0 ? "100%" : "50%"};
      margin-left: ${(props) => props.imgPriceAditional === 0 ? "15px" :"0px"} ;

    }
  
  }
  .upload-message-text{
   background: #F4F4F4;
   padding: 10px;
   border-radius: 8px;
  }

  .uploadImgMobile{
    padding:2px;
  }
  .row-image{
    margin-left: 10px;
  }
`
export const CardWrapper = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: ${(props) => (props.statusAdvertise != 'Rechazada' ? ' 250px 15% 30% 30%' : ' 150px 25% 32% 25%')};
  ${'' /* ${(props) => (props.imgPriceAditional > 0 ? '270px 1fr 1fr 30%' : ' 30% 30% 40%')}; */}
  grid-gap: 0 20px;
  margin-left: ${(props) => (props.statusAdvertise != 'Rechazada' ? '' : ' -15px')};
  @media (max-width: 768px) {
    grid-template-columns: 250px 15% 30% 30%;
    margin-left: 0px;
  }
  @media (max-width: 1024px) {
    grid-template-columns:  1fr 1fr;
    grid-gap: 0;
    flex-wrap: wrap;
    .TitleAdvertise,
    .City  {
      grid-column: 1 / -1;
      grid-gap: 15px;
    }
    .TitleAdvertise {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }


  }
  .imgCtr{
    margin-left: -10px;
    @media (max-width: 768px) {
      margin-left: 8px;
    }
  }

  .DateStart{
    @media (max-width: 768px) {
      margin-top: ${(props) => (props.statusAdvertise != 'Rechazada' ? ' 90px' : '')}; 
      padding-left: ${(props) => (props.statusAdvertise != 'Rechazada' ? ' 0px' : '0px')};
    }    
  }

  .DateEnd{
    @media (max-width: 768px) {
      margin-top: ${(props) => (props.statusAdvertise !== 'Rechazada' ? '20px' : '0px')};
      padding-left: ${(props) => (props.statusAdvertise !== 'Rechazada' ? '30px' : ' 20px')}; 
    }    
  }
`


export const CardTitle = styled.div`
  width: 170px;
  display: inline-flex;
  flex-direction: column;
  .title {
    margin-bottom: 15px;
    > div:first-child {
      display: flex;
    }
  }
  .Img {
    text-align: center;
    @media (max-width: 1024px) { 
      text-align: left;
    }
  }
  @media (max-width: 1024px) {
    width: 100%;
    margin-right: 0;
    flex-direction: row;
  }
 
 
`
export const RowC = styled(Row)`
 @media only screen and (max-device-width: 767px) {
  margin-left: 10px;
  }
`

export const DivTitle = styled.div`
 @media only screen and (max-device-width: 767px) {
    display: none;
  }`


export const Line = styled.div`
  width: 4px;
  background-color:  ${({ theme }) => theme.colors.graySuperLightness};
  @media only screen and (max-device-width: 767px) {
    display: none;
  }
  margin: 0px 20px 0px 30px;

  
`

export const State = styled.span`
  display: block;
  border-radius: 4px;
  width: 100px;
  height: 18px;
  font: 14px/18px 'DMSans-Regular';
  text-align: center;
  margin-top: 5px;
  margin-left: 0px;
  &.Aceptada {
    color: ${({ theme }) => theme.colors.success};
    background: ${({ theme }) => theme.colors.successLight};
  }
  &.Pendiente {
    color: ${({ theme }) => theme.colors.pending};
    background: ${({ theme }) => theme.colors.pendingLight};
  }
  &.Rechazada {
    color: ${({ theme }) => theme.colors.error};
    background: ${({ theme }) => theme.colors.errorLight};
  }
  @media (max-width: 1024px) {
    float: left;
    margin-top: 3px;
    margin-right: 0;
    width: 80px;
  }
  @media (max-width: 768px) {
    float: left;
        margin-top: 3px;
        margin-right: 0;
        width: 100px;
        height: 20px;
  }
`
export const Link = styled.a`
  color: ${({ theme }) => theme.colors.secondary};
  cursor: pointer;
  display: contents;
  text-align: center;
  text-decoration: none;
  padding-right: 10px;
  margin-left: 20px;
    img {
    width: 70px;
    height: 90%;
    @media (max-width: 768px) {
      width: 70px;
      height: 70px;
      object-fit: contain;
    }
  }
  svg {
    margin: 12px 0;
  }
  span {
    display: none;
    @media (max-width: 1024px) {
      display: block;
    }
  }
  @media (min-width: 768px) {
    width: 50%;
    margin-left: 5px;
    flex-direction: row;
    img{
      width: 70px;
    }
  } 
  .img-price-aditional{
    @media (min-width: 768px) {
      width: 70px;
      margin-left: 5px;
      img{
        width: 70px;
      }
    }
  }
`


export const Format = styled.div`
  display: inline-block;
  font: 14px/24px 'DMSans-Medium';
  color: ${({ theme }) => theme.colors.third};
  svg {
    vertical-align: middle;
    margin-bottom: 4px;
    margin-right: 5px;
    fill: #8E9194;
  }
`

export const ButtonContent = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: inline-block;
  padding: 0;
  &:focus {
    outline: none;
  }
  img {
    width: 70px;
    border: 1px solid #a6a9ab;
    @media (max-width: 768px) {
      //width: auto;
      height: 60px;
      object-fit: contain;
      //object-position: left;
    }
  }
`
export const DashedDiv = styled.div`  
    border: 2px dashed #C8D2D3; /* gris claro */
    border-radius: 12px;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right:10px;
   `

export const ColActions = styled.div`
     display: flex;
     flex-direction: column;
     alignItems: 'flex-start'  ;

     .actionMaterial{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .messageDigital{
        margin: 0px 26px 0px 0px;
      }
     }
   ` 

   export const ColImg = styled.div`
     display: flex;
     flex-direction: column;
     alignItems: 'flex-start'  ;

     .infoText{
      @media (max-width: 768px) {
        background-color: #F4F4F4;
        padding: 15px;
      }      
     }
     .imgUploadMobile{
      @media (max-width: 768px) 
      {
        padding: 10px;
        margin: 0 auto;
      }
     }
   ` 